module.exports = __webpack_public_path__ + "static/media/download.b2097f9d.svg";